export default __webpack_public_path__ + "static/media/ferry.f14a78ff.svg";